const URL = {
  sendCheckCode: '/common/user/user/send_check_code', // 发送短信验证码
  commonLogin: '/common/user/user/common_login', // 手机号验证码登录
  getUserInfo: '/vehicle/activity/business_wechat_official/info/', // 获取用户信息
  getAllDicts: '/vehicle/activity/business_dict/get_all_dicts', // 字典
  getAdvertPush: '/vehicle/business/static/get_advert_push', // 广告位
  addAnnualMeeting: '/vehicle/activity/annual_meeting/add', // 新增报名
  getAnnualMeeting: '/vehicle/activity/business_voting_activity/default/info', // 获取默认商务年会活动
  getMySignupList: '/vehicle/activity/annual_meeting/my/signup', // 我的报名列表
  getAnnualMeetingInfo: '/vehicle/activity/annual_meeting/info', // 获取报名详情
  updateAnnualMeeting: '/vehicle/activity/annual_meeting/update', // 报名修改
  deleteAnnualMeeting: '/vehicle/activity/annual_meeting/delete', // 删除报名
  arrivalOcr: '/vehicle/activity/annual_meeting/arrival_ocr', // 年会到达信息图片识别

  getAnnualMeetingSignin: '/vehicle/activity/annual_meeting/my/signin', // 我的签到列表
  addAnnualMeetingSign: '/vehicle/activity/annual_meeting_sign_in/add_batch', // 签到
  getAnnualMeetingSigninPagelist: '/vehicle/activity/annual_meeting_sign_in/pagelist', // 签到记录

  getWxSign: '/vehicle/activity/business_wechat_official/share/sign', // 微信签名

  getPhotoType: '/vehicle/activity/business_annual_live_broadcast_type/list', // 获取直播主题分类
  getPhotoList: '/vehicle/activity/annual_live_broadcast_picture/pagelist', // 获取直播图片
  getPhotoInfo: '/vehicle/activity/annual_live_broadcast_picture/info', // 获取直播图片详情
  searchFace: '/vehicle/activity/annual_meeting/searchFace', // 人脸搜索接口

  getAnnualMeetingBadgeList: '/vehicle/activity/annual_meeting_badge/list', // 勋章列表
  addAnnualMeetingBadge: '/vehicle/activity/annual_meeting_badge/add', // 勋章领取接口
  getAnnualMeetingBadgeInfo: '/vehicle/activity/annual_meeting_badge_info/query_badge_info', // 用户核销码
  writeOff: '/vehicle/activity/annual_meeting_badge_info/write_off', // 工作人员核销

  upload: '/vehicle/activity/annual_meeting_footprint_photo/upload', // 上传
  addAnnualMeetingFootprintPhoto: '/vehicle/activity/annual_meeting_footprint_photo/add', // 上传时光足迹照片
  getAnnualMeetingFootprintPhotoList: '/vehicle/activity/annual_meeting_footprint_photo/list', // 个人时光足迹列表

  getMeetingSign: '/userApi/businessCard/activity/meeting/sign', // 获取问卷
  signAnswer: '/userApi/businessCard/activity/signAnswer', // 提交答案
  getMeetingSignSummary: '/userApi/businessCard/activity/meeting/sign/summary', // 统计

  addAdvertClick: '/vehicle/business/business_advert_click/add', //
  getAdvertClickList: '/vehicle/business/business_advert_click/list', //
  getArticleInfo: '/vehicle/business/business_article/info/', // 获取文章详情
  getChargePhone: '/vehicle/activity/business_dict/get_charge_phone', // 紧急联系人

  addDriverRecruit: '/vehicle/business/driver_recruit/add' // 新增司机招募令
}

export default URL
